import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PublicLayout } from './components/layout/PublicLayout';
import { AdminLayout } from './components/layout/AdminLayout';

// Public Pages
import { HomePage } from './pages/public/HomePage';
import { AboutPage } from './pages/public/AboutPage';
import { LeadershipPage } from './pages/public/LeadershipPage';
import { BlogIndexPage } from './pages/public/BlogIndexPage';
import { BlogShowPage } from './pages/public/BlogShowPage';
import { ContactPage } from './pages/public/ContactPage';

// Admin Pages
import { AdminLoginPage } from './pages/admin/AdminLoginPage';
import { AdminDashboardPage } from './pages/admin/AdminDashboardPage';
import { AdminPostsPage } from './pages/admin/AdminPostsPage';
import { AdminPostEditPage } from './pages/admin/AdminPostEditPage';
import { AdminPagesPage } from './pages/admin/AdminPagesPage';
import { AdminExperiencesPage } from './pages/admin/AdminExperiencesPage';
import { AdminAchievementsPage } from './pages/admin/AdminAchievementsPage';
import { AdminMediaPage } from './pages/admin/AdminMediaPage';
import { AdminContactPage } from './pages/admin/AdminContactPage';
import { AdminSettingsPage } from './pages/admin/AdminSettingsPage';
import { AdminAuditLogsPage } from './pages/admin/AdminAuditLogsPage';

const NotFoundPage: React.FC = () => (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4 py-20 bg-radial-glow">
        <span className="text-emerald-400 text-xs font-bold uppercase tracking-wider mb-2">404 Error</span>
        <h1 className="text-4xl sm:text-6xl font-extrabold text-white mb-4">Page Not Found</h1>
        <p className="text-slate-400 max-w-md mb-8">
            The page you requested could not be found on Rakib's Care platform.
        </p>
        <Link to="/" className="px-6 py-3 rounded-full text-sm font-semibold bg-emerald-600 hover:bg-emerald-500 text-white transition">
            Return to Homepage &rarr;
        </Link>
    </div>
);

export const App: React.FC = () => {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    {/* Public Website Routes */}
                    <Route element={<PublicLayout />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/leadership" element={<LeadershipPage />} />
                        <Route path="/blog" element={<BlogIndexPage />} />
                        <Route path="/blog/:slug" element={<BlogShowPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Route>

                    {/* Admin Authentication & Secret Entry */}
                    <Route path="/rakib69" element={<AdminLoginPage />} />
                    <Route path="/rakib69/login" element={<AdminLoginPage />} />
                    <Route path="/admin/login" element={<AdminLoginPage />} />

                    {/* Protected Admin CMS Routes */}
                    <Route path="/admin" element={<AdminLayout />}>
                        <Route index element={<AdminDashboardPage />} />
                        <Route path="dashboard" element={<AdminDashboardPage />} />
                        <Route path="posts" element={<AdminPostsPage />} />
                        <Route path="posts/new" element={<AdminPostEditPage />} />
                        <Route path="posts/:id" element={<AdminPostEditPage />} />
                        <Route path="pages" element={<AdminPagesPage />} />
                        <Route path="experiences" element={<AdminExperiencesPage />} />
                        <Route path="achievements" element={<AdminAchievementsPage />} />
                        <Route path="media" element={<AdminMediaPage />} />
                        <Route path="contact" element={<AdminContactPage />} />
                        <Route path="settings" element={<AdminSettingsPage />} />
                        <Route path="audit" element={<AdminAuditLogsPage />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
};

export default App;
